import { TextButton } from '@oneaudi/unified-web-components';
import styled from 'styled-components';

export const ParallaxTeaser = styled.div`
  max-width: 1920px;
  margin: 0 auto;
`;

export const ParallaxArea = styled.div`
  position: relative;
  overflow: hidden;
  height: 1000px;

  @media (min-width: ${({ theme }) => theme.breakpoints.md}px) {
    height: 1400px;
  }
  @media (min-width: ${({ theme }) => theme.breakpoints.xl}px) {
    height: 1600px;
  }
`;

export const StyledLayout = styled.div`
  position: absolute;
  backface-visibility: hidden;
  width: 100%;
  left: 0;
  z-index: 1;
  will-change: transform;
  display: flex;
  justify-content: center;

  @media (min-width: ${({ theme }) => theme.breakpoints.md}px) {
    justify-content: flex-start;
  }
`;

export const StyledLayoutItem = styled.div`
  position: relative;
  box-sizing: border-box;
  background-color: ${({ theme }) => theme.colors.globalColorElevation};
  display: flex;
  flex-direction: column;
  gap: 24px;
  flex-shrink: 0;
  flex-basis: 86%;
  margin: 40px auto 0 auto;
  padding: var(--spacing-relative-2xl);
  @media (min-width: ${({ theme }) => theme.breakpoints.md}px) {
    left: 4%;
    position: relative;
    flex-basis: 56%;
    margin: 48px 0 0;
  }
  @media (min-width: ${({ theme }) => theme.breakpoints.lg}px) {
    margin: 60px 0 0;
  }
  @media (min-width: ${({ theme }) => theme.breakpoints.xl}px) {
    flex-basis: 44%;
    margin: 80px 0 0;
  }
  @media (min-width: ${({ theme }) => theme.breakpoints.xxl}px) {
    margin: 100px 0 0;
  }
`;

export const LegalArea = styled.div`
  background-color: ${({ theme }) => theme.colors.baseColor};
  justify-content: center;
`;

export const LegalAreaItem = styled.div`
  padding-top: ${({ theme }) => theme.spacing.sysSpaceFixed200};
  padding-right: var(--page-margin);
  padding-bottom: ${({ theme }) => theme.spacing.sysSpaceFixed200};
  padding-left: var(--page-margin);
  shrink: 0;
  flex-basis: 86%;
  @media (min-width: ${({ theme }) => theme.breakpoints.md}px) {
    flex-basis: 92%;
  }
`;

export const WltpWrapper = styled.span`
  display: block;
`;

export const WltpSpan = styled.span``;

export const StyledTextButton = styled(TextButton)`
  > span {
    white-space: nowrap;
  }
`;

export const StyledImg = styled.img`
  position: absolute;
  left: 50%;
  transform: translate3d(-50%, 0, 0);
  will-change: transform;
  backface-visibility: hidden;
`;
